import InventoryListSkeletonItem from './InventoryListSkeletonItem';

export default InventoryListSkeletonItem;
